module.exports = __webpack_public_path__ + "84c046514d82dd186d744b80cfaff50c.pdf";